/**
 * Study-derived fields merged into CRE `mirror-state` (page → extension).
 * Ephemeral lines use `useCreMirrorFeedback` and are merged in `useCreMirrorPayloadExtension`.
 *
 * When adding keys: follow `hooks/cre/index.js` (CRE contract checklist). Types:
 * `CREExtension/src/types/mirrorProtocol.ts`. Constants: `creMirrorConstants.js`.
 *
 * @param {{ patientName?: string; accessionNo?: string; gender?: string } | null | undefined} summary
 * @returns {{ patientName: string; accessionNo: string; patientGender: string }}
 */
export function mirrorPayloadExtensionFromPatientSummary(summary) {
  const s = summary ?? {};
  return {
    patientName: typeof s.patientName === "string" ? s.patientName : "",
    accessionNo: typeof s.accessionNo === "string" ? s.accessionNo : "",
    patientGender: typeof s.gender === "string" ? s.gender : "",
  };
}
